// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { i18n } from '../../index'
import { Button, Paper } from '@mui/material'
import StationPage from './StationPage'
import EmployeeForm from './EmployeeForm'
import EmployeeList from './EmployeeList'
import ExternalEmployeeDialog from './ExternalEmployeeDialog'
import css from './stationPage.css'
type StationEmployeePageState = {
  isDialogOpen: boolean
}

class StationEmployeePage extends React.PureComponent<any, StationEmployeePageState> {
  state = {
    isDialogOpen: false,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    })
  }

  render() {
    const { isDialogOpen } = this.state
    return (
      <StationPage title={i18n.t('admin.stations.title.employeesPage')}>
        {({ station }) => (
          <div className={css.component}>
            <EmployeeForm station={station} />
            <Paper>
              <EmployeeList stationId={get(station, 'id')} data={get(station, 'users', [])} />
            </Paper>
            <div className={css.bottom}>
              <Button onClick={this.openDialog} variant='contained' color='primary'>
                {i18n.t('admin.stations.label.createExternalEmployeeButton')}
              </Button>
            </div>
            <ExternalEmployeeDialog stationId={get(station, 'id')} isOpen={isDialogOpen} onClose={this.closeDialog} />
          </div>
        )}
      </StationPage>
    )
  }
}

export default StationEmployeePage
